import { Grid, FormControl, Box, Input, InputLabel } from '@material-ui/core';
import { useContext } from 'react';
import { Controller } from 'react-hook-form';
import FormContext from '../FormContext';
import { InputFieldProps, ObjectLike } from '../types';
import { toCapital } from '../utils';
import { componentGridStyle, toolTipChildStyle } from '../styles';

/**
 * Use this component to capture a string entered by the user.
 * @param name your schema field name
 * @param title your schema field title
 * @param style optional style object
 * @param options optional options object
 * @param children optional children components
 * @param size optional size of the component
 */
export function FormInput<T extends ObjectLike>({
  name,
  title,
  style,
  options,
  children,
  size = 4,
}: InputFieldProps<T>) {
  const { ctx } = useContext(FormContext);

  return (
    <Grid item xs={12} sm={12} md={size} style={componentGridStyle}>
      <FormControl variant="outlined" fullWidth>
        <Controller
          name={name}
          control={ctx.control}
          render={({ field: { value, ...field }, fieldState }) => (
            <Box display="flex" alignItems="center">
              <InputLabel variant="standard" htmlFor={name}>
                {title || toCapital(name)}
              </InputLabel>
              <Input
                aria-label={`${name.toString().toLowerCase()}-${options?.type}input`}
                id={name}
                inputProps={options?.inputProps}
                fullWidth
                required={options?.required === undefined ? true : options.required}
                error={fieldState.error ? true : false}
                style={style}
                {...{ variant: 'outlined', ...options }}
                {...field}
                {...(options?.type === 'file' ? {} : { value: value ?? '' })}
              />
              {children && (
                <Box ml={1} style={toolTipChildStyle}>
                  {children}
                </Box>
              )}
            </Box>
          )}
        />
      </FormControl>
    </Grid>
  );
}
